export const GET_CHALLENGES = 'challenge/GET_CHALLENGES';
export const GET_CHALLENGES_SUCCESS = 'challenge/GET_CHALLENGES_SUCCESS';
export const GET_CHALLENGES_ERROR = 'challenge/GET_CHALLENGES_ERROR';

// Client-facing: the cohorts the logged-in client belongs to (invited/active).
export const GET_MY_COHORTS = 'challenge/GET_MY_COHORTS';
export const GET_MY_COHORTS_SUCCESS = 'challenge/GET_MY_COHORTS_SUCCESS';
export const GET_MY_COHORTS_ERROR = 'challenge/GET_MY_COHORTS_ERROR';
